export const EXSBWAREHOUSEITEM_DELETE_RESET = 'EXSBWAREHOUSEITEM_DELETE_RESET'
export const EXSBWAREHOUSEITEM_DELETE_SET_ERROR = 'EXSBWAREHOUSEITEM_DELETE_SET_ERROR'
export const EXSBWAREHOUSEITEM_DELETE_SET_DELETED = 'EXSBWAREHOUSEITEM_DELETE_SET_DELETED'
export const EXSBWAREHOUSEITEM_DELETE_TOGGLE_LOADING = 'EXSBWAREHOUSEITEM_DELETE_TOGGLE_LOADING'
